import React from 'react'
import { connect } from 'react-redux'

class DailyPrize extends React.Component {

  render() {

    const {radiothonDaily} = this.props
    const dailyPrize = radiothonDaily.items.map( ( item, index) =>
      <div onClick={(e) => this.clicked(item, e)} className='daily-prize' key={index}>
        <img src={item.field_event_image[0].url} style={{maxWidth: '100%', float: 'left'}} />
        <h3>{item.title[0].value}</h3>
        <div dangerouslySetInnerHTML={{ __html: item.body[0].value }}></div>
        {/*<div>{item.field_event_teaser[0].value}</div>*/}
        <div style={{clear: 'both' }} />
      </div>
    )
    return (
      <div>
        <h2>Today's Daily Prize</h2>
        {dailyPrize}
      </div>
    )

  }

}

export default connect(state => ({radiothonDaily: state.radiothonDaily})) (DailyPrize)
